<template>
  <div class="users-page p-4">
    <!-- Header -->
    <div class="d-flex align-items-center justify-content-between mb-3 pb-2 border-bottom">
      <h3 class="mb-0 font-weight-bold text-dark">ຈັດການຜູ້ໃຊ້ງານ</h3>
      <b-button variant="primary" @click="Openformuser" class="shadow-sm px-4 py-2">
        <b-icon icon="person-plus-fill" class="mr-2"></b-icon> {{ $t("button.add") }}
      </b-button>
    </div>

    <!-- Search bar -->
    <b-row class="mb-3">
      <b-col md="5">
        <b-input-group>
          <b-input-group-prepend is-text>
            <b-icon icon="search"></b-icon>
          </b-input-group-prepend>
          <b-form-input
            v-model="searchQuery"
            :placeholder="$t('button.search')"
            @input="currentPage = 1"
          ></b-form-input>
          <b-input-group-append v-if="searchQuery">
            <b-button variant="outline-secondary" @click="searchQuery = ''; currentPage = 1">
              <b-icon icon="x"></b-icon>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col md="3" class="d-flex align-items-center">
        <small class="text-muted">ທັງໝົດ {{ filteredItems.length }} ລາຍການ</small>
      </b-col>
      <b-col md="4" class="d-flex align-items-center justify-content-end">
        <span class="text-muted mr-2 small">ສະແດງ:</span>
        <b-form-select
          v-model="perPage"
          :options="[10, 20, 50, 100]"
          size="sm"
          style="width: 75px"
          @change="currentPage = 1"
        ></b-form-select>
        <span class="text-muted ml-2 small">ລາຍການ/ໜ້າ</span>
      </b-col>
    </b-row>

    <!-- Table -->
    <b-card no-body class="shadow border-0 rounded-lg overflow-hidden">
      <b-card-body class="p-0">
        <b-table
          hover
          responsive
          :items="filteredItems"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="null"
          show-empty
          empty-text="ບໍ່ມີຂໍ້ມູນ"
          class="mb-0"
        >
          <template #cell(default_module)="data">
            <b-badge :variant="data.item.default_module === 'CCA' ? 'success' : 'primary'">
              {{ data.item.default_module || 'SLFIS' }}
            </b-badge>
          </template>
          <template #cell(action)="data">
            <div class="d-flex justify-content-end">
              <b-button
                variant="outline-primary"
                size="sm"
                class="mr-2"
                @click="onEdit(data.item)"
              >
                <b-icon icon="pencil-square"></b-icon>
              </b-button>
              <b-button
                variant="outline-danger"
                size="sm"
                @click="del(data.item.username)"
              >
                <b-icon icon="trash-fill"></b-icon>
              </b-button>
            </div>
          </template>
        </b-table>
      </b-card-body>
    </b-card>

    <!-- Pagination -->
    <div class="d-flex justify-content-center mt-3" v-if="filteredItems.length > perPage">
      <b-pagination
        v-model="currentPage"
        :total-rows="filteredItems.length"
        :per-page="perPage"
        first-number
        last-number
        pills
        align="center"
      ></b-pagination>
    </div>

    <!-- User Modal Form -->
    <b-modal
      ref="user-modal"
      hide-footer
      centered
      size="lg"
      header-class="card-header-gradient text-white border-0"
      title-class="font-weight-bold"
      :title="$t('users.title')"
    >
      <b-form class="p-3" @submit="onSubmit">
        <b-row>
          <b-col md="6">
            <b-form-group :label="$t('users.username')" label-class="label-style">
              <b-form-input v-model="fld.username" class="custom-input" required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :label="$t('users.password')" label-class="label-style">
              <b-form-input v-model="fld.password" type="password" class="custom-input" :required="!fld.id"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group :label="$t('users.fullname')" label-class="label-style">
              <b-form-input v-model="fld.fullname" class="custom-input" required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :label="$t('users.org_type_code')" label-class="label-style">
              <b-form-select v-model="fld.org_type_code" :options="org_type" class="custom-select-styled" required></b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :label="$t('users.user_level')" label-class="label-style">
              <b-form-select v-model="fld.user_level" :options="levels" class="custom-select-styled" required></b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :label="$t('users.branch_id')" label-class="label-style">
              <b-form-select v-model="fld.prov_id" :options="branchs" @input="getDep" class="custom-select-styled"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :label="$t('users.dep_code')" label-class="label-style">
              <b-form-select v-model="fld.district_id" :options="dep" @input="getscholls" class="custom-select-styled"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="8">
            <b-form-group :label="$t('users.scholl')" label-class="label-style">
              <b-form-select v-model="fld.school_id" :options="schools" class="custom-select-styled"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group :label="$t('users.Active')" label-class="label-style">
              <b-form-select v-model="fld.active" :options="Active" class="custom-select-styled" required></b-form-select>
            </b-form-group>
          </b-col>

          <!-- default_module -->
          <b-col md="12">
            <b-form-group :label="$t('users.default_module')" label-class="label-style">
              <div class="d-flex">
                <b-form-radio-group
                  v-model="fld.default_module"
                  :options="moduleOptions"
                  buttons
                  button-variant="outline-primary"
                  class="w-100"
                ></b-form-radio-group>
              </div>
            </b-form-group>
          </b-col>
        </b-row>

        <div class="mt-4 pt-2">
          <b-button block type="submit" variant="primary" class="save-btn py-2 shadow font-weight-bold rounded-pill">
            <b-icon icon="save-fill" class="mr-2"></b-icon> {{ $t('button.save') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";

const emptyFld = () => ({
  id: "",
  username: "",
  email: "",
  password: "",
  employee_id: "",
  default_module: "SLFIS",
  user_level: "",
  user_roles: "",
  last_login: "",
  last_update: "",
  created: "",
  login_hash: "",
  lang: "",
  border_id: "",
  prov_id: "",
  district_id: "",
  school_id: "",
  fullname: "",
  org_type_code: "",
  active: 1,
});

export default {
  props: {},
  created() {
    let login = localStorage.getItem("Login");
    this.user = JSON.parse(login);
    this.fld.prov_id = this.user.district_id.substring(0, 2);
    this.fld.district_id = this.user.district_id;

    this.loadUsers();
    this.getDep();
    this.getscholls();

    const headers = { Authorization: "Bearer " + this.user.login_hash };
    const base = this.$store.getters.getBaseUrl;

    axios.get(`${base}/getItems/levels/level_desc/level_id`, { headers })
      .then(r => { this.levels = r.data; }).catch(console.error);

    axios.get(`${base}/getItems/org_type/org_type_desc/org_type_code`, { headers })
      .then(r => { this.org_type = r.data; }).catch(console.error);

    axios.get(`${base}/getItems/province/prov_name/prov_id`, { headers })
      .then(r => { this.branchs = r.data; }).catch(console.error);
  },
  data() {
    return {
      user: null,
      searchQuery: "",
      currentPage: 1,
      perPage: 20,
      branchs: [],
      dep: [],
      fields: [
        { label: this.$t("users.username"), key: "username", thStyle: { background: "#1B4F72", color: "#fff" }, sortable: true },
        { label: this.$t("users.fullname"), key: "fullname", thStyle: { background: "#1B4F72", color: "#fff" }, sortable: true },
        { label: this.$t("users.province_name"), key: "prov.prov_name", thStyle: { background: "#1B4F72", color: "#fff" } },
        { label: this.$t("users.level_desc"), key: "level.level_desc", thStyle: { background: "#1B4F72", color: "#fff" } },
        { label: this.$t("users.default_module"), key: "default_module", thStyle: { background: "#1B4F72", color: "#fff" }, thClass: "text-center", tdClass: "text-center" },
        { label: "Action", key: "action", thStyle: { background: "#1B4F72", color: "#fff" }, thClass: "text-right", tdClass: "text-right" },
      ],
      items: [],
      fld: emptyFld(),
      levels: [],
      schools: [],
      org_type: [],
      Active: [
        { value: 1, text: "Yes" },
        { value: 0, text: "No" },
      ],
      moduleOptions: [
        { text: "SLFIS", value: "SLFIS" },
        { text: "CCA", value: "CCA" },
      ],
    };
  },
  computed: {
    filteredItems() {
      if (!this.searchQuery.trim()) return this.items;
      const q = this.searchQuery.toLowerCase();
      return this.items.filter(item => {
        return (
          (item.username || "").toLowerCase().includes(q) ||
          (item.fullname || "").toLowerCase().includes(q) ||
          (item.email || "").toLowerCase().includes(q) ||
          ((item.prov && item.prov.prov_name) || "").toLowerCase().includes(q)
        );
      });
    },
  },
  methods: {
    loadUsers() {
      axios
        .get(
          `${this.$store.getters.getBaseUrl}/users_district/${this.user.district_id}`,
          { headers: { Authorization: "Bearer " + this.user.login_hash } }
        )
        .then(r => { this.items = r.data; })
        .catch(console.error);
    },
    Openformuser() {
      this.fld = emptyFld();
      this.fld.prov_id = this.user.district_id.substring(0, 2);
      this.fld.district_id = this.user.district_id;
      this.$refs["user-modal"].show();
    },
    getDep() {
      axios
        .get(
          `${this.$store.getters.getBaseUrl}/getItemsCondition/district/district_name_lao/district_id/prov_id/${this.fld.prov_id}`,
          { headers: { Authorization: "Bearer " + this.user.login_hash } }
        )
        .then(r => { this.dep = r.data; })
        .catch(console.error);
    },
    getscholls() {
      axios
        .get(
          `${this.$store.getters.getBaseUrl}/getItemsCondition/schools/school_name_lao/school_id/district_id/${this.fld.district_id}`,
          { headers: { Authorization: "Bearer " + this.user.login_hash } }
        )
        .then(r => { this.schools = r.data; })
        .catch(console.error);
    },
    onSubmit(event) {
      event.preventDefault();
      axios
        .post(
          `${this.$store.getters.getBaseUrl}/adduser`,
          { item: this.fld },
          { headers: { Authorization: "Bearer " + this.user.login_hash, "Content-Type": "application/json" } }
        )
        .then(r => {
          if (r.data.code == "1") {
            this.$bvToast.toast("ບັນທຶກສຳເລັດແລ້ວ", {
              title: "Success",
              toaster: "b-toaster-top-right",
              variant: "success",
              solid: true,
            });
            this.loadUsers();
          } else {
            this.$bvToast.toast("ບໍ່ສາມາດອັບເດດ, ກະລຸນາລອງໃໝ່.", {
              title: "Error",
              toaster: "b-toaster-top-right",
              variant: "danger",
              solid: true,
            });
          }
          this.$refs["user-modal"].hide();
        })
        .catch(console.error);
    },
    onEdit(row) {
      this.fld = Object.assign(emptyFld(), row);
      if (!this.fld.default_module) this.fld.default_module = "SLFIS";
      this.getDep();
      this.getscholls();
      this.$refs["user-modal"].show();
    },
    del(username) {
      this.$bvModal
        .msgBoxConfirm("ກະລຸນາຢືນຢັນ ທ່ານຕ້ອງການລົບລາຍການນີ້ອອກຈາກລະບົບ.", {
          title: "ຢືນຢັນການລົບ",
          size: "md",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "ລົບ",
          cancelTitle: "ຍົກເລີກ",
          centered: true,
        })
        .then(ok => {
          if (!ok) return;
          axios
            .post(
              `${this.$store.getters.getBaseUrl}/deluser`,
              { table: "users", pkey: "username", code: username },
              { headers: { Authorization: "Bearer " + this.user.login_hash } }
            )
            .then(r => {
              if (r.data.code == 1) {
                this.$bvToast.toast("ລົບລາຍການສຳເລັດແລ້ວ.", {
                  title: "ສຳເລັດ",
                  toaster: "b-toaster-top-right",
                  variant: "success",
                  solid: true,
                });
                this.loadUsers();
              } else {
                this.$bvToast.toast(r.data.msg || "ລົບລາຍການລົ້ມເຫຼວ.", {
                  title: "Error",
                  toaster: "b-toaster-top-right",
                  variant: "danger",
                  solid: true,
                });
              }
            })
            .catch(console.error);
        })
        .catch(console.error);
    },
  },
};
</script>

<style scoped>
.card-header-gradient {
  background: linear-gradient(135deg, #1b4f72, #2980b9);
}
</style>
